import { pushPageView } from './index';

export const onRouteUpdate = ({ location }, { pageViewData }) => {
  if (location?.pathname && !location?.pathname.includes('maintenance')) {
    pushPageView(location?.pathname, pageViewData);
  }
};
